module.exports = __webpack_public_path__ + "img/tu09.eaa9faeb.png";